// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-J":"NA_outdoor-recreation-J__Sc48T"};